import { selectIsMobile } from "modules/deviceInfo";
import { useSelector } from "react-redux";
import useWhitelabelMode, {
  WhitelabelMode,
} from "../../hooks/useWhitelabelMode";
import BaseLogo from "../BaseLogo";
import { useStyles } from "./styles";

const ConversationModeLeftLogo = () => {
  const classes = useStyles();
  const isMobileView = useSelector(selectIsMobile);
  const [whitelabelMode] = useWhitelabelMode();
  const VARIANT = "powered-by-conversation";

  // we do not show the conversation mode logo if on mobile,
  // or if no custom event whitelabelling config was found
  if (
    isMobileView ||
    (whitelabelMode !== WhitelabelMode.CUSTOM_EVENT_BRANDING_LOGO &&
      whitelabelMode !== WhitelabelMode.CUSTOM_EVENT_COMPANY_LOGO)
  )
    return null;

  return <BaseLogo logoVariant={VARIANT} containerClass={classes.container} />;
};

export default ConversationModeLeftLogo;
